import { render, staticRenderFns } from "./ThankYouOrderOnlinePickUp.vue?vue&type=template&id=48fc4c1e&scoped=true&"
import script from "./ThankYouOrderOnlinePickUp.vue?vue&type=script&lang=js&"
export * from "./ThankYouOrderOnlinePickUp.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouOrderOnlinePickUp.vue?vue&type=style&index=0&id=48fc4c1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc4c1e",
  null
  
)

export default component.exports